import React from "react";
import { Navigate } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import CommonIdentity from "../pages/Authentication/CommonIdentity";

//On Call schedule management
import OnCallPolicyList from "../pages/OnCallPolicyList/index";
import CreatePolicy from "../pages/OnCallPolicyList/CreatePolicy";
import PolicyDetails from "../pages/OnCallPolicyList/PolicyDetails";

//Service
import Service from "../pages/Service/index";
import ServiceDetails from "../pages/Service/ServiceDetails";
import AddService from "../pages/Service/AddService";

//Service
import Team from "../pages/Team/index";
import AddTeam from "../pages/Team/AddTeam";

//Cloud Resource
import CloudResource from "../pages/CloudResource/index";

import DataSources from "../pages/AppsyncAwsDataSources/index";

import Resolvers from "../pages/AppsyncAwsResolvers/index";

import NewRelicResource from "../pages/NewRelicResource/index";

import GCPResources from "../pages/GCPResources/index";

import AzureResources from "../pages/AzureResources";

import Threshold from "../pages/Threshold/index";

import NewRelicThreshold from "../pages/NewRelicThreshold/index";

import GCPThreshold from "../pages/GCPThreshold/index";

import DatadogThreshold from "../pages/DatadogThreshold/index";

import SplunkThreshold from "../pages/SplunkThreshold/index";

import AppDynamicsThreshold from "pages/AppDynamicsThreshold/index";

import AppDynamicsResourceTransactions from "pages/AppDynamicsBusinessTransactions/index";

import GrafanaResources from "../pages/GrafanaResources/index";

import Alert from "../pages/Alert/index";

import DynatraceAlert from "../pages/DynatraceAlert/index";

import NewRelicAlert from "../pages/NewRelicAlert/index";

import GCPAlert from "../pages/GCPAlert/index";

import AzureAlert from "../pages/AzureAlert/index"

import DatadogResource from "../pages/DatadogResource/index";

import SplunkResource from "../pages/SplunkResource/index";

import SplunkServiceDependency from "../pages/SplunkServiceDependency/index";

import SplunkAlert from "../pages/SplunkAlert/index";

import DatadogAlert from "../pages/DatadogAlert/index"

import DatadogServiceDependency from "../pages/DatadogServiceDependency/index";

import AllRecentResources from "pages/RecentlyAddedResources/AllRecentResources";


//Rca
import RcaForm from "pages/Rca/RcaForm";
import Rca from "pages/Rca/Rca";

//Status-Page
import StatusPage from "pages/StatusPage/StatusPage";
import StatusPageManagement from "pages/StatusPage/StatusPageManagement";
import CreateIncident from "pages/StatusPage/CreateIncident";
import UpdateIncident from "pages/StatusPage/UpdateIncident";
import AssociateAlerts from "pages/StatusPage/AssociateAlerts"
import StatusPageMailConfirmation from "pages/StatusPage/StatusPageMailConfirmation";

//Logging Systems
import SentryProjects from "pages/Sentry/SentryProjects";
import Loki from "pages/Loki/Loki";
import Coralogix from "pages/Coralogix/Coralogix";


// Subscriptions
import Subscription from "pages/Subscriptions/Subscription"

// Alcom Score Dashboard


// Alcom Score Dashboard
import AlcomScoreDashboard from "../pages/AlcomScoreDashboard/index";

// New Relic Transaction
import NewRelicTransactions from "../pages/NewRelicTransaction/index"


import NewRelicExternalServices from "../pages/NewRelicExternalServices/index";

// Datadog Api Endpoints
import DatadogApiEndpoints from "../pages/DatadogApiEndpoints/index";


import AppdynamicsNonKeyTransactions from "../pages/AppdynamicsNonKeyTransactions/index";

import AwsServiceQuotas from "../pages/AwsServiceQuota/index";

//Cloud On boarding
import CloudOnboarding from "../pages/Onboarding/CloudOnboarding";

import NewRelicOnboarding from "../pages/Onboarding/NewRelicOnboarding";

import OpsGenieOnboarding from "../pages/Onboarding/OpsGenieOnboarding";

import MasterSystem from "../pages/Onboarding/MasterSystem";

import ServiceOnboarding from "../pages/Onboarding/ServiceOnboarding";

import DefaultOnboarding from "../pages/Onboarding/DefaultOnboarding";

import MSTeamsOnboarding from "../pages/Onboarding/MSTeamsOnboarding";


// Dashboard
import Dashboard from "../pages/Dashboard/index";

import Calendar from "../pages/OnCallPolicyList/OnCallCalender";

//PingMonitoring
import PingMonitoring from "../pages/PingMonitoring/index";
import AddPingMontoring from "../pages/PingMonitoring/AddPingMonitoring";

// Organization
import OrganizationPage from "../pages/Organization/Organization";
import InviteConfirmation from "../pages/InviteConfirmation/InviteConfirmation";
import OpsGenieTeams from "../pages/OpsGenie/OpsGenie";
import PagerdutyServices from "../pages/Pagerduty/Pagerduty";
import Profile from "../pages/Profile/Profile";
import EmailConfirmation from "../pages/EmailConfirmation/EmailConfirmation";
import ServiceEmailConfirmation from "../pages/ServiceEmailConfirmation/ServiceEmailConfirmation";
import Pages500 from "../pages/ErrorPages/Pages500";
import Pages404 from "../pages/ErrorPages/Pages404";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import Pricing from "../pages/Pricing/Pricing";
import AlertLog from '../pages/AlertLog/AlertLog'
import AlertLogDetails from "../pages/AlertLog/AlertLogDetails";

//Alert Analytics based pages
import AlertAnalytics from "../pages/AlertAnalytics/index";
import AzureThreshold from "pages/AzureThreshold";
import AlertsForOptimization from "../pages/AlertsForOpitmization/index";

import MSTeams from "../pages/MSTeams/index";
import MSTeamsList from "../pages/MSTeams/MSTeamsList";
import AppDynamicsResources from "pages/AppDynamicsResources/index";
import AppDynamicsAlerts from "pages/AppDynamicsAlert/index";
import AppDynamicsExternalServices from "../pages/AppDynamicsExternalServices/index";
import DynatraceResources from "../pages/Dynatrace/index";
import DynatraceThreshold from "../pages/DynatraceThreshold";
import DynatraceKeyUserActionResources from "../pages/DynatraceKeyUserActions/index";
import DynatraceUserActions from "../pages/DynatraceUserActions/index";
import OciThreshold from "../pages/OciThreshold/index"
import OciResources from "../pages/Oci/index";
import OciAlerts from "../pages/OciAlert/index";
import Alerts from "../pages/Alerts";
import AlertCorrelation from "../pages/AlertCorrelation/index";
import AlertLogDetailsIndex from "../pages/AlertLog/AlertLogDetailsIndex";
import OktaCallBackComp from "../pages/Authentication/OktaCallback";
import GrafanaResourceTab from "../pages/GrafanaResources/GrafanaResourceTab";
import GrafanaAlert from "../pages/GrafanaAlert";
import GrafanaThreshold from "../pages/GrafanaThreshold";
import GrafanaExternalService from "../pages/GrafanaExternalServices";
import GrafanaNonKeyTransactions from "../pages/GrafanaNonKeyTransactions";
import GrafanaResourceTransactions from "../pages/GrafanaBuisnessTransactions";
import DaemonPage from "../pages/Daemon/"
import DaemonOnboardingPage from "../pages/DaemonOnboarding";
import DaemonDetailsPage from '../pages/DaemonDetails'
import SignozResources from "../pages/SIgnozResources";
import SignozAlert from "../pages/SignozAlert";
import SignozThreshold from "../pages/SignozThreshold";
import SignozResourceTransactions from "../pages/SignozBuisnessTransactions";
import SignozExternalService from "../pages/SignozExternalServices";
import SignozNonKeyTransactions from "../pages/SignozNonKeyTransactions";
import DaemonLambdasPage from "../pages/DaemonLambdas";
import LambdaAlertMapPage from "../pages/DaemonLambdas/LambdaAlertMap";
import RootCauseAnalysisIndex from "../pages/RootcauseAnalysis";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  //onCall Schedule Management
  { path: "/oncall-policies", component: <OnCallPolicyList /> },
  { path: "/oncall-policies/create", component: <CreatePolicy /> },
  { path: "/oncall-policies/:id", component: <PolicyDetails /> },

  //service
  { path: "/temperstack-notifications", component: <Service /> },
  { path: "/temperstack-notifications/:id", component: <ServiceDetails /> },
  { path: "/add-service", component: <AddService /> },

  //team
  { path: "/teams", component: <Team /> },
  { path: "/add-team", component: <AddTeam /> },

  //recently-added-resources
  {path: "/recently-added-resources", component: <AllRecentResources/>},

  //cloud-resource
  { path: "/cloud-resources", component: <CloudResource /> },

  //new-relic-resource
  { path: "/new-relic-resources", component: <NewRelicResource /> },

  //gcp-resource
  { path: "/gcp-resources", component: <GCPResources /> },


  //azure-resource
  {path:"/azure-resources", component: <AzureResources />},

  //datadog-resource
  { path: "/datadog-resources", component: <DatadogResource /> },

  //appdynamics-reosurce
  { path: "/appdynamics-resources", component: <AppDynamicsResources/>},

  { path: "/grafana-resources", component: <GrafanaResources />},
  { path: "/grafana/resource/:resourceId/alerts", component: <GrafanaAlert/>},
  { path: "/grafana-thresholds", component: <GrafanaThreshold/>},
  { path: "/grafana-transactions", component: <GrafanaResourceTransactions />},
  { path: "/grafana-external-services", component: <GrafanaExternalService/>},
  { path:"/grafana/resource/:resourceId/transactions", component: <GrafanaNonKeyTransactions />},

  { path: "/signoz-resources", component: <SignozResources />},
  { path: "/signoz/resource/:resourceId/alerts", component: <SignozAlert/>},
  { path: "/signoz-thresholds", component: <SignozThreshold/>},
  { path: "/signoz-transactions", component: <SignozResourceTransactions />},
  { path: "/signoz-external-services", component: <SignozExternalService/>},
  { path:"/signoz/resource/:resourceId/transactions", component: <SignozNonKeyTransactions />},

  { path: "/datadog-service-dependency", component: <DatadogServiceDependency />},

  //splunk-resource
  { path: "/splunk-resources", component: <SplunkResource /> },

  { path: "/splunk-service-dependency", component: <SplunkServiceDependency /> },


  //configure-threshold
  { path: "/thresholds", component: <Threshold /> },

  { path: "/resource/:resourceId/alerts", component: <Alert /> },

  { path: "/newrelic/resource/:resourceId/alerts", component: <NewRelicAlert /> },

  { path: "/gcp/resource/:resourceId/alerts", component: <GCPAlert /> },


  { path: "/azure/resource/:resourceId/alerts", component: <AzureAlert /> },

  { path: "/datadog/resource/:resourceId/alerts", component: <DatadogAlert />  },

  { path: "/splunk/resource/:resourceId/alerts", component: <SplunkAlert />  },

  { path :"/appdynamics/resource/:resourceId/alerts", component: <AppDynamicsAlerts />},

  {path:"/appdynamics-transactions", component: <AppDynamicsResourceTransactions />},

  {path: "/appdynamics-external-services", component: <AppDynamicsExternalServices />},

  //new-relic-threshold
  { path: "/new-relic-thresholds", component: <NewRelicThreshold /> },

  { path: "/new-relic-external-services", component: <NewRelicExternalServices /> },

  //gcp-threshold
  { path: "/gcp-thresholds", component: <GCPThreshold /> },


  { path: "/azure-thresholds", component: <AzureThreshold /> },

  { path: "/datadog-thresholds", component: <DatadogThreshold /> },

  { path: "/splunk-thresholds", component: <SplunkThreshold /> },

  { path: "/appdynamics-thresholds", component: <AppDynamicsThreshold />},



  // path to new relic transaction

  { path: "/newrelic/resource/:resourceId/transactions", component: <NewRelicTransactions /> },

  {path:"/appdynamics/resource/:resourceId/transactions", component: <AppdynamicsNonKeyTransactions />},

  // path to datadog api endpoints

  { path: "/datadog/api-endpoints", component: <DatadogApiEndpoints /> },

  // path to aws appsync data sources
  {path:"/cloud-resources-appsync-data-sources", component: <DataSources />},

// path to aws appsync resolvers
  {path:"/cloud-resources-appsync-resolvers", component: <Resolvers />},

  //organization-profile
  { path: "/organization", component: <OrganizationPage /> },

  { path: "/opsgenie-teams", component: <OpsGenieTeams /> },

  { path: "/pagerduty-services", component: <PagerdutyServices /> },

  { path: "/profile", component: <Profile /> },

  { path: "/pricing", component: <Pricing /> },

  { path: "/alert-log", component: <AlertLog /> },

  { path: "/alerts", component: <Alerts/>},

  { path: "/alert-log/:id", component: <AlertLogDetailsIndex /> },
  //
  { path: "/alert-log/:id/ack", component: <AlertLogDetailsIndex /> },
  //
  { path: "/alert-log/:id/resolve", component: <AlertLogDetailsIndex /> },

  //Analytics based navigation
  { path: "/alert-analytics", component: <AlertAnalytics /> },

  { path: "/alerts-for-optimization", component: <AlertsForOptimization /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/", exact: true, component: <Navigate to="/dashboard" />,
  },

  {
    path: "/*", exact: true, component: <Navigate to="/pages-404" />,
  },

  {
    path: "/alcom-score-dashboard", component: <AlcomScoreDashboard />
  },

  { path: "/msteams/onboarding", component: <MSTeamsOnboarding /> },

  {path: "/alert-log-correlation/:id", component: <AlertCorrelation />},

  { path: "/msteams", component: <MSTeams /> },

  { path: "/msteams/list", component: <MSTeamsList /> },

  {path: "/dynatrace-resources", component: <DynatraceResources />},

  {path:"/dynatrace/resource/:resourceId/alerts", component: <DynatraceAlert />},

  {path:"/dynatrace-thresholds", component: <DynatraceThreshold />},

  {path:"/dynatrace-key-user-actions", component: <DynatraceKeyUserActionResources />},

  {path:"/dynatrace-user-actions", component: <DynatraceUserActions />},

  {path: "/oci-resources", component: <OciResources />},

  {path:"/oci/resource/:resourceId/alerts", component: <OciAlerts />},
  // PingMonitoring
  { path: "/ping-monitoring", component: <PingMonitoring /> },

  { path: "/add-ping-monitoring", component: <AddPingMontoring />},
  { path: "/edit-endpoint", component: <AddPingMontoring />},

  // Rca
  { path: "/rca-form", component: <RcaForm /> },
  { path: "/rca-form/:rcaId", component: <RcaForm />},

  { path: "/rca", component: <Rca /> },
  { path: "/rca/:actionItemId", component: <Rca/>},

  //Status-Page
  {path: "/status-page-management", component: <StatusPageManagement />},
  {path: "/create-incident",component: <CreateIncident />},
  {path: "/incidents/:id", component: <UpdateIncident />},
  {path: "/associate-alerts-with-statuspage",component:<AssociateAlerts/>},
   {path: "/oci-thresholds", component: <OciThreshold />},
  {path:"/aws-service-quota", component: <AwsServiceQuotas />},

  //Logging Systems
  {path: "/sentry-projects", component: <SentryProjects />},
  {path: "/loki", component: <Loki />},
  {path: "/coralogix", component: <Coralogix />},

  //Subscriptions
  {path: "/subscriptions", component:<Subscription/>},

  //Daemon routes
  { path: "/daemon", component: <DaemonPage/>},
  { path: "/daemon-onboarding", component: <DaemonOnboardingPage/>},
  { path: "/daemon/:daemonId", component: <DaemonDetailsPage />},
  { path: "/daemon-lambdas", component: <DaemonLambdasPage/>},
  { path: "/daemon-lambdas/map", component: <LambdaAlertMapPage/>},
  {path: "/alert-log-analysis/:id", component: <RootCauseAnalysisIndex />},
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/aws-onboarding", component: <CloudOnboarding /> },
  { path: "/ops-genie-onboarding", component: <OpsGenieOnboarding /> },
  { path: "/new_relic/onboarding", component: <NewRelicOnboarding /> },
  { path: "/azure/onboarding", component: <CloudOnboarding /> },
  { path: "/master-system", component: <MasterSystem /> },
  { path: "/service-onboarding", component: <ServiceOnboarding /> },
  { path: "/invite-confirmation/:token", component: <InviteConfirmation /> },
  { path: "/confirmation/:token", component: <EmailConfirmation /> },
  { path: "/service-email-confirmation/:token", component: <ServiceEmailConfirmation /> },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  { path: "/error500", component: <Pages500 /> },
  { path: "/error404", component: <Pages404 /> },
  { path: "/identity", component: <CommonIdentity /> },
  {path:"/okta-callback", component: <OktaCallBackComp />},
  {}
];

const statusPageRoutes = [
  { path: "/status-page", component: <StatusPage />},
  { path: "/statuspage/confirm-subscription/:token", component: <StatusPageMailConfirmation /> },
  {}
];

const onBoardingRoutes = [
  { path: "/onboarding", component: <DefaultOnboarding /> },
];

export { authProtectedRoutes, publicRoutes, onBoardingRoutes, statusPageRoutes };
